<ix-application>
  <ix-application-header [name]="applicationName()">
    <user-auth />
  </ix-application-header>
  <ix-menu
    enableToggleTheme="true"
    [i18nLegal]="'NAVIGATION.ABOUT_AND_LEGAL' | translate"
    [i18nSettings]="'NAVIGATION.SETTINGS' | translate">
    <ix-menu-item icon="home" routerLink="/">{{ 'NAVIGATION.HOMEPAGE' | translate }}</ix-menu-item>
    <ix-menu-item icon="license" routerLink="/permissions">{{ 'NAVIGATION.PERMISSIONS' | translate }}</ix-menu-item>
    <ix-menu-item icon="user" routerLink="/users">{{ 'NAVIGATION.USERS' | translate }}</ix-menu-item>
    <ix-menu-item icon="project" routerLink="/projects">{{ 'NAVIGATION.PROJECTS' | translate }}</ix-menu-item>
    <ix-menu-item icon="code" routerLink="/tokens">{{ 'NAVIGATION.TOKENS' | translate }}</ix-menu-item>
    <ix-menu-item icon="tree" routerLink="/domains">{{ 'NAVIGATION.DOMAINS' | translate }}</ix-menu-item>

    <!-- Settings -->
    <ix-menu-settings>
      <settings />
    </ix-menu-settings>

    <!-- About and legal -->
    <ix-menu-about [label]="'NAVIGATION.ABOUT_AND_LEGAL' | translate">
      <about-info />
    </ix-menu-about>
  </ix-menu>
  <ix-content>
    <router-outlet />
  </ix-content>
</ix-application>
